import deburr from 'lodash.deburr'

export default function deburrAndLowerCase(value: string) {
  return deburr(value.trim()).toLowerCase()
}
